import type { ApplicationData } from '@xing-com/crate-jobs-helpers';

import { useInterviewBooking } from '../../hooks';
import { useMainActions } from '../header/actions/use-main-actions';

type Props = { application: ApplicationData };

export const useInterviewBookingFlags = ({
  application,
}: Props): { adobe: string; nwt: string } => {
  const { jobId, slug } = application;
  const { hasBookedInterview, hasInterviewButtonAvailable } =
    useInterviewBooking({ jobId, slug });
  const { showApplyButton } = useMainActions(application);
  const hasInterviewSupport = hasInterviewButtonAvailable || hasBookedInterview;
  const interviewSupport = hasInterviewSupport ? 'true' : 'false';
  const applyButton = showApplyButton ? 'active' : 'inactive';
  const flags = [
    `interview_support_${interviewSupport}`,
    `apply_button_${applyButton}`,
  ];

  if (hasInterviewSupport) {
    const interviewButton = hasInterviewButtonAvailable ? 'active' : 'inactive';
    flags.splice(1, 0, `interview_button_${interviewButton}`);
  }

  const adobe = flags.map((flag) => `jobs_${flag}`).join(',');
  const nwt = flags.join(',');

  return { adobe, nwt };
};
